import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to embedded workspace notify their height.
 */
export class ViewSizeCommandBody implements CommandBody {
  height: string;
}
